<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'LegalFooter',
    computed: {
      ...mapState('auth', [
        'signup_config',
        'settings',
      ]),
      ...mapState('pages', [ 'legal_pages' ]),
    },
    mounted() {
      this.getLegalPages()
    },
    methods: {
      ...mapActions('pages', [ 'getLegalPages' ]),
    },
  }
</script>
